import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidepanel',
  templateUrl: './sidepanel.component.html',
  styleUrls: ['./sidepanel.component.css'],
})
export class SidepanelComponent implements OnInit {
  logo: any;
  constructor() {}

  ngOnInit(): void {
    this.checkIfTenant();
  }

  checkIfTenant() {
    const isTenant = localStorage.getItem('tenant');
    if (isTenant === 'true') {
      const { hostname } = new URL(window.location.href);

      this.logo =
        hostname === 'fidelity-cpaas.terragonltd.com'
          ? '../assets/icons/fidelity.svg'
          : hostname === 'oxygen-cpaas.terragonltd.com'
          ? '../assets/icons/oxygen.svg'
          : hostname === 'abstaging-cpaasdev.terragoncpaas.com'
          ? '../assets/icons/access.svg'
          : hostname === 'ocpaasstaging.terragonbase.com' ||
            hostname === 'acc-cpaas.terragonltd.com'
          ? '../assets/icons/terragonLogo.svg'
          : hostname === 'aramex.terragoncpaas.com'
          ? '../assets/icons/aramex.svg'
          : hostname === 'hydrogencpaas.terragoncpaas.com'
          ? '../assets/icons/hydrogen.svg'
          : '../assets/icons/user-dummy.png';
    } else {
      this.logo = '../../../assets/icons/terragonLogo.svg';
    }
  }
}
